import React, { useMemo, useRef, useState } from "react";
import { GroupByKey } from "../../../Library/GlobalHelper";
import { AlertNotif } from "../../../Library/AlertNotif";
import { openModal } from "../../../Library/ModalPopUp";
import { PopOver, ToolTip } from "../../../Library/Overlays";
import CourseDetail from "./CourseDetail";

export default function TableSemesterCourse({ data }) {
  const elective_course = {
    coursetitle: "Elective Course",
    status: "ACTIVE",
    code: "",
  };

  const status_taken = (item) => {
    let status = "";
    if (item.course_type === "asc.course.type.mandatory") {
      if (item.course_taken && Object.values(item.course_taken).length > 0) {
        status = status_taken_id(item.status_taken);
      } else {
        status = "NOT YET TAKEN";
      }
    } else if (item.course_type === "asc.course.type.specialization") {
      if (item.status_taken) {
        status = status_taken_id(item.status_taken);
      } else {
        status = "NOT YET TAKEN";
      }
    } else {
      if (item.status_taken) {
        status = status_taken_id(item.status_taken);
      } else {
        status = "NOT YET TAKEN";
      }
    }
    return status;
  };
  const course_list = useMemo(() => {
    let computedData = [];
    if (Object.values(data.curr_dt).length > 0) {
      const grouped_course = GroupByKey(data.curr_dt, "semester");
      computedData = Object.keys(grouped_course).map((c, index) => ({
        index: index + 1,
        semester: parseInt(c),
        courses: grouped_course[c].map((v) => ({
          id: v.id,
          course_id: v.course_id ? v.course_id : 9,
          type: v.course_type,
          credit: v.credit,
          ects: v.ects,
          is_core: v.is_core_course,
          order: v.order,
          status: status_taken(v),
          course: v.course ? v.course : elective_course,
          course_taken: v.course_taken ? v.course_taken : null,
        })),
      }));
    }
    return computedData;
  }, [data]);

  const course_list_eligible = useMemo(() => {
    let computedData = [];
    if (Object.values(data.elective_course).length > 0) {
      computedData = {
        index: computedData.length + 1,
        semester: "elective_course_list",
        courses: Object.values(data.elective_course).map((v) => ({
          id: v.id,
          course_id: v.t_course_id ? v.t_course_id : 9,
          type: "asc.course.type.specialization",
          credit: v?.t_course?.credit,
          ects: v?.t_course?.ects,
          course: v.t_course,
          status: status_taken(v),
          course_taken: v.course_taken ? v.course_taken : null,
        })),
      };
    } else {
      computedData = {
        index: computedData.length + 1,
        semester: "elective_course_list",
        courses: [],
      };
    }

    return computedData;
  }, [data]);

  const course_list_other = useMemo(() => {
    let computedData = [];
    if (Object.values(data.other_course).length > 0) {
      computedData = {
        index: computedData.length + 1,
        semester: "other_course_list",
        courses: Object.values(data.other_course).map((v) => ({
          status: status_taken(v),
          course: v.course_taken ? v.course_taken : null,
          credit: v.course_taken ? v.course_taken?.credit : 0,
        })),
      };
    } else {
      computedData = {
        index: computedData.length + 1,
        semester: "other_course_list",
        courses: [],
      };
    }
    return computedData;
  }, [data]);

  return Object.values(course_list).length > 0 ? (
    <>
      <div className="row">
        {course_list.map((v, index) => (
          <ListSemester key={index} data={v} />
        ))}
      </div>
      <div className="separator my-2"></div>
      <div className="row">
        <ListSemester data={course_list_eligible} />
        <ListSemester data={course_list_other} />
      </div>
    </>
  ) : (
    <AlertNotif message="No record found" color="info" />
  );
}

const ListSemester = ({ data }) => {
  const { totalCredit } = useMemo(() => {
    return data.courses.reduce(
      (acc, course) => ({
        totalCredit: acc.totalCredit + (course.credit || 0),
      }),
      { totalCredit: 0 }
    );
  }, [data]);
  const courseType = (type) => {
    let course_type = "";
    if (type === "asc.course.type.mandatory") {
      course_type = "Mandatory";
    } else if (type === "asc.course.type.specialization") {
      course_type = "Elective";
    }
    return course_type;
  };
  const color_status = (status, is_text = false) => {
    return (
      status &&
      (status === "PASS"
        ? "success"
        : status === "FAILED"
        ? "danger"
        : is_text
        ? "warning"
        : "white")
    );
  };

  return (
    <div className="col-6">
      <table className="table table-bordered table-row-dashed align-middle gl-3 gy-2 my-3">
        <thead>
          <tr className="h-6 font-weight-bold bg-light">
            <th colSpan={5} className="pl-2">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <i className="fa fa-calendar mr-1 icon-1x"></i>
                  <span className="font-weight-bold text-capitalize">
                    {data.semester === "elective_course_list"
                      ? "Eligible Elective Courses"
                      : data.semester === "optional_course_list"
                      ? "Optional Courses"
                      : data.semester === "other_course_list"
                      ? "Other Courses Credit"
                      : `Semester ${data.semester}`}
                  </span>
                  {data.semester === "other_course_list" && (
                    <ToolTip
                      title={"Not credited toward the graduation"}
                      position="top"
                    >
                      <span className="mx-2">
                        <i className="flaticon2-information text-info icon-1x"></i>
                      </span>
                    </ToolTip>
                  )}
                </div>
                <div className="font-size-sm font-weight-bold">
                  <span className="mr-1">Total Credit: {totalCredit} SKS</span>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.courses.map((v, index) => (
            <tr
              key={index}
              className={"font-weight-bold bg-light-" + color_status(v.status)}
            >
              <td>
                {v.course_id !== 9 ? (
                  <>
                    {v.course.status !== "ACTIVE" && (
                      <span className="badge badge-danger">
                        {v.course.status}
                      </span>
                    )}
                    <div className="d-flex align-items-center">
                      <div>
                        {v.course_id ? (
                          <span
                            className="text-dark text-hover-primary cursor-pointer"
                            onClick={() =>
                              openModal({
                                header: "Course Selected",
                                message: (
                                  <CourseDetail course_id={v.course_id} />
                                ),
                                size: "lg",
                              })
                            }
                          >
                            {v.course.code ? `${v.course.code} · ` : ""}
                            {v?.course?.coursetitle}
                          </span>
                        ) : (
                          <span className="text-dark">
                            {v.course.code ? `${v.course.code} · ` : ""}
                            {v?.course?.coursetitle}
                          </span>
                        )}
                      </div>
                      {v.course_taken &&
                        Object.values(v.course_taken).length > 0 &&
                        v.course_id !== v.course_taken.course_id && (
                          <ButtonCourseTaken data={v.course_taken} />
                        )}
                    </div>
                  </>
                ) : (
                  <span className="text-dark">
                    {v.course.code ? `${v.course.code} · ` : ""}
                    {v?.course?.coursetitle}
                  </span>
                )}
              </td>
              <td style={{ width: "150px" }} className="text-center">
                Credit {v?.credit} SKS
              </td>
              <td style={{ width: "150px" }} className="text-center">
                <span className={"text-" + color_status(v.status, true)}>
                  {v?.status}
                </span>
              </td>
              <td style={{ width: "60px" }} className="text-center">
                {courseType(v.type).charAt(0)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const ButtonCourseTaken = ({ data }) => {
  return (
    <ToolTip
      title={"Click for view courses Taken Based on Equivalency"}
      position="right"
    >
      <button
        type="button"
        className="btn btn-sm btn-icon p-0"
        onClick={() =>
          openModal({
            header: "Courses Taken Based on Equivalency",
            message: <CourseTaken course={data} />,
          })
        }
      >
        <div className="cursor-pointer">
          <i className="flaticon2-refresh text-info icon-1x"></i>
        </div>
      </button>
    </ToolTip>
  );
};

const CourseTaken = ({ course }) => {
  return (
    <div>
      <p className="mb-0">
        {course?.code}
        <span className="mx-1">·</span>
        {course?.coursetitle}
      </p>
    </div>
  );
};

const status_taken_id = (id) => {
  if (id === 1) {
    return "PASS";
  } else if (id === 2) {
    return "FAILED";
  } else {
    return "NOT YET TAKEN";
  }
};
